export class FlowStep {
  FlowOid?: number;
}
